import { send } from '../../../fix-search/API'

export const sessionManageAction = (action, sessionId, data) => {
    let value = ''
    switch (action) {
        case 'activate':
            value = `"${sessionId}"`
            break
        case 'deactivate':
            value = `"${sessionId}"'`
            break
        case 'removeSession':
            value = `'["${sessionId}",false]'`
            break
        case 'reset':
            value = `'{"@Reset":{"sessionID":"${sessionId}"}}'`
            break
        case 'seqRead':
            value = `'{"@SeqSet":{"sessionID":"${sessionId}", number:${data}}'`
            break
        case 'seqWrite':
            value = `'{"@SeqSet":{"sessionID":"${sessionId}", number:${data}}'`
            break
        case 'addSession':
            value = data.replace(/\s\s+/g, ' ')
            break
        case 'sendFixConfig':
            value = ''
            break
        case 'replaceSession':
            value = `[${data}, false]`
            break
        default:
            return
    }
    return send(action, value)
}
